import React from 'react';
import { Calendar, Clock, Tag, Share2 } from 'lucide-react';
import { Button } from '../ui/button';
import ResponsiveImage from '../ResponsiveImage';

const BlogPostHeader = ({ post, onShare }) => {
  const formattedDate = new Date(post.date).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });

  return (
    <header className="mb-12" data-testid="blog-post-header">
      <div className="mb-4">
        <span className="blog-category-badge inline-block">{post.category}</span>
      </div>

      <h1 className="article-title mb-6" data-testid="blog-post-title">
        {post.title}
      </h1>

      <div className="article-meta mb-8">
        <div className="flex gap-6 flex-wrap">
          <span className="blog-meta-item">
            <Calendar size={18} aria-hidden="true" />
            {formattedDate}
          </span>
          <span className="blog-meta-item">
            <Clock size={18} aria-hidden="true" />
            {post.readTime}
          </span>
          <span className="blog-meta-item">
            <Tag size={18} aria-hidden="true" />
            {post.author}
          </span>
        </div>
        <Button
          className="btn-secondary"
          onClick={onShare}
          data-testid="blog-post-share-btn"
        >
          <Share2 size={18} className="mr-2" aria-hidden="true" />
          Share
        </Button>
      </div>

      <div className="article-image mb-12">
        <ResponsiveImage
          src={post.image}
          alt={post.title}
          widths={[600, 1000, 1600]}
          sizes="(max-width: 768px) 100vw, 80vw"
          loading="eager"
        />
      </div>
    </header>
  );
};

export default BlogPostHeader;
